import { forwardRef } from 'react'
import { Stack, type StackProps } from './Stack'

type OmittedProps = 'direction'
type VStackProps = Omit<StackProps, OmittedProps>

const VStack = forwardRef(({ ...props }: VStackProps, ref) => {
  return <Stack ref={ref} direction="column" {...props} />
})

export { VStack, type VStackProps }
